class imagesGrid {
  constructor (items, id, completeCallback = null, autoplay = 0, itemsPerSlide = 15, maxItems = 45) {
    this.items = items
    this.id = id
    this.itemsPerSlide = itemsPerSlide
    this.maxItems = maxItems
    this.autoplay = autoplay

    // Carousel.
    this.imgGridContainer = document.getElementById(
      this.id)
    this.imgGrid = this.imgGridContainer.querySelector('.swiper-container')
    this.imgGridWrapper = this.imgGrid.querySelector('.swiper-wrapper')
    // Modal.
    let modalId = this.imgGridContainer.getAttribute('data-modal')
    this.modal = document.getElementById(modalId)
    // Start.
    this.calculateMaxItems()
    // this.shuffleArray()
    this.createSlides()
    this.createCarousel()

    if (completeCallback) {
      completeCallback()
    }
  }

  calculateMaxItems () {
    let w = window.innerWidth

    if (w <= 1023) {
      this.maxItems = this.maxItems > 30 ? 30 : this.maxItems
    }
    else {
      this.maxItems = this.maxItems > 45 ? 45 : this.maxItems
    }

    this.maxItems = this.maxItems > this.items.length ? this.items.length : this.maxItems
  }

  createSlides () {
    let slide = null
    for (let i = 0; i < this.maxItems; i++) {
      let item = this.items[i]
      if (i % this.itemsPerSlide === 0) {
        slide = this.createSlide()
      }
      this.createItem(slide, item, i)
    }
  }

  createSlide () {
    let slide = document.createElement('div')
    slide.classList.add('img-grid--slide')
    slide.classList.add('swiper-slide')
    // Preloader.
    // let lazy_preloader = document.createElement('div')
    // lazy_preloader.classList.add('swiper-lazy-preloader')
    // slide.appendChild(lazy_preloader)

    this.imgGridWrapper.appendChild(slide)
    return slide
  }

  createItem (slide, itemData, index) {
    if (!itemData) {
      return;
    }

    let self = this,
      imgUrl = itemData.filename,
      name = itemData.name,
      location = itemData.place,
      profession = itemData.jobTitle

    /**
     * Grid item.
     * @type {HTMLDivElement}
     */

    let container = document.createElement('div')
    container.classList.add('image-grid--item')
    container.setAttribute('data-img', imgUrl)
    container.setAttribute('data-name', name)
    container.setAttribute('data-location', location)
    container.setAttribute('data-profession', profession)
    container.setAttribute('data-index', index)

    container.addEventListener('click', (e) => {
      self.modal.classList.add('open')
      self.modal.querySelector('.swiper-container').swiper.update()
      self.modal.querySelector('.swiper-container').swiper.slideTo(index, 0)
      console.log('Open', self.modal.querySelector('.swiper-container').swiper)
    })

    /**
     * Image.
     * @type {HTMLImageElement}
     */
    let dir = '../assets/images/photos/small/'
    let itemImageWrapper = document.createElement('div')
    itemImageWrapper.classList.add('img-grid--item-image-wrapper')

    let item = document.createElement('img')
    item.setAttribute('data-src', '../assets/images/photos/small/' + imgUrl)
    item.classList.add('swiper-lazy')

    itemImageWrapper.style.backgroundImage = 'url(' + dir + imgUrl + ')'

    // itemImageWrapper.appendChild(item)

    /**
     * Details.
     * @type {HTMLDivElement}
     */

    let itemDetailsContainer = document.createElement('div')
    itemDetailsContainer.classList.add('img-grid--item-details')

    let itemName = document.createElement('div')
    itemName.classList.add('img-grid--item-name')
    itemName.textContent = name

    let itemLocation = document.createElement('div')
    itemLocation.classList.add('img-grid--item-location')
    itemLocation.textContent = location

    let itemProfession = document.createElement('div')
    itemProfession.classList.add('img-grid--item-profession')
    itemProfession.textContent = profession

    itemDetailsContainer.appendChild(itemName)
    itemDetailsContainer.appendChild(itemLocation)
    itemDetailsContainer.appendChild(itemProfession)

    /**
     * Add to DOM.
     */

    container.appendChild(itemImageWrapper)
    container.appendChild(itemDetailsContainer)

    slide.appendChild(container)
  }

  createCarousel () {
    let self = this
    new Swiper(this.imgGrid, {
      loop: (self.items.length / self.itemsPerSlide) > 1,
      slidesPerView: 1,
      centeredSlides: true,
      speed: 500,
      threshold: 100,
      lazy: true,
      autoplay: (self.autoplay > 0 ? { delay: self.autoplay } : undefined),
      // If we need pagination
      pagination: {
        el: self.imgGridContainer.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: self.imgGridContainer.querySelector('.swiper-button-next'),
        prevEl: self.imgGridContainer.querySelector('.swiper-button-prev'),
      },
      watchOverflow: true,
      on: {
        init: function () {
          self.swiper = this
          self.initialized = true
        },
        slideChange: function () {
          self.swiper = this
        },
        slideChangeTransitionStart: function () {
          self.swiper = this
          if (self.initialized === true) {
            //self.gridAnim()
          }
        },
      },
      breakpoints: {
        768: {
          // slidesPerView: 1.25, (if more than 1 slide)
          slidesPerView: self.items.length / self.itemsPerSlide > 1 ? 1.25 : 1.1,
        },
      },
    })
  }
}